<template>
    <div class="slider-banner swiper-style" :style="swiperStyle">
      <swiper :options="{...swiperOption,...imgOption}" v-if="data.length > 0">
        <swiper-slide v-for="(item, index) in data" :key="index">
          <img class="page-image" :style="swiperImgStyle" :src="item.pic" />
        </swiper-slide>
        <div class="swiper-pagination paginationBanner" slot="pagination"></div>
      </swiper>
    </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@assets/css/swiper.min.css";
let vms = null;

export default {
    name: "Swiper",
    components: {
        swiper,
        swiperSlide
    },
    props: {
        swiperStyle: {
            type: Object,
            default: ()=>{}
        },
        data: {
            type: Array,
            default: ()=>[
                {
                    pic: "",
                    wap_url: ""
                }
            ]
        },
        imgOption: {
            type: Object,
            default: {
                autoplay: false,
                loop: false
            }
        },
        swiperImgStyle: {
            type: Object,
            default: ()=>{}
        }
    },
    data: function() {
        return {
            currentShopNav: 0,
            swiperOption: {
                pagination: {
                    el: ".paginationBanner",
                    clickable: true
                },
                speed: 1000,
                observer: true,
                observeParents: true,
                on: {
                    tap: function() {
                        const realIndex = this.realIndex;
                        vms.goUrl(realIndex);
                    }
                }
            }
        }
    },
    created() {
        vms = this;
    },
    methods: {
        // 轮播图跳转
        goUrl(index) {
            let url = this.data[index].wap_url;
            let newStr = url.indexOf("http") === 0;
            if (newStr) {
                window.location.href = url;
            } else {
                this.$emit("goToUrl", index)
            }
        },
    }
}
</script>

<style scoped>
.swiper-style {
    width: 100%;
    height: 100%;
}
</style>